import React from 'react';
import useCreateEmr from '@/screens/CreateEmr/store';
import useGlobalMobileConfigs from '@/stores/globalConfigsMobile';
import { usePhrMobileStoreInContext } from '@/stores/phrMobile';
import { Form, Input } from 'antd';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import emrService from '@/apis/emr/service';
import utils from '@/utils';
import { TYPE_POST_MESSAGE } from '@/hooks/useMessageWebview';
import { convertDataRecursive } from '@/screens/CreateEmr/FormCreateEmr';
import RecursivelyCreateForm from '@/screens/CreateEmr/RecursivelyCreateForm';

const PHRMobileLogs = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { emrType: emrTypeInit, initValues, disabled } = location.state;
  const refetchPhr = usePhrMobileStoreInContext((s) => s.refetchPhr);

  const [form] = Form.useForm();
  const emrTypes = useGlobalMobileConfigs((s) => s.emrTypes);
  const emrType = emrTypes?.[emrTypeInit];
  const params = useParams();
  const uid = params.uid as string;
  const { mutate } = emrService.useUpsert();
  const setIsFormChange = useCreateEmr((s) => s.setIsFormChange);

  React.useEffect(() => {
    utils.postMessage({
      type: TYPE_POST_MESSAGE.VIEW_SCREEN,
      data: {
        screen: 'PHR_LOGS',
      },
    });
    return () => {
      utils.postMessage({
        type: TYPE_POST_MESSAGE.UN_VIEW_SCREEN,
        data: {
          screen: 'PHR_LOGS',
        },
      });
    };
  }, []);

  const onSubmit = () => {
    const raw = form.getFieldsValue(true);
    const data = convertDataRecursive(raw);
    const payload = {
      ...data,
      uid,
      type: emrTypeInit,
      tags: data.tags,
      _id: initValues?._id,
    };
    mutate(payload, {
      onSuccess() {
        setIsFormChange(false);
        refetchPhr?.();
        navigate(-1);
        utils.postMessage({
          type: TYPE_POST_MESSAGE.RELOAD_HEALTH_DATA,
          data: {
            emrType: emrTypeInit,
            uid,
          },
        });
      },
    });
  };

  return (
    <div className="overflow-auto h-full bg-gray-2">
      <Form
        initialValues={initValues}
        onValuesChange={() => setIsFormChange(true)}
        disabled={disabled}
        form={form}
        layout="vertical"
        onFinish={onSubmit}
      >
        <Form.Item name={'_id'} hidden>
          <Input />
        </Form.Item>
        <div className="p-4 bg-white mx-6 mt-4 shadow-md rounded-lg mb-4">
          <RecursivelyCreateForm emrType={emrType} fields={emrType?.format?.fields} disabled={disabled} />
        </div>
        <div className="mx-6 mb-4 justify-center flex">
          <button type="submit" className="h-9 bg-gradient-1 rounded-full justify-center items-center w-full">
            <span className="text-white pl-2 cms-h5">Lưu</span>
          </button>
        </div>
      </Form>
    </div>
  );
};

export default PHRMobileLogs;
